import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel } from '../../shared';
import {Core2Config} from '../../shared';
import { EntityMergingProcessingContainerModel } from "../../../../../../models/aggregates/erp/entity";


@Injectable({
  providedIn: 'root'
})

export class EntityMergingProcessingService extends BaseApiTemplateService<EntityMergingProcessingContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-merging-processing/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-merging-processing/backoffice-ep'
    this.httpClient = http;
  }

}
